import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon } from 'assets/icons';
import { CampaignService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import { CampaignImage } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: ''
}

class SendCampaign extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha y Hora',
			'Nº',
			'Mensaje',
			'Total Destinatarios',
			'Total Entregados',
			'Total Fallidos'			
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Campañas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		// @ts-ignore
		if (this.props.history.location?.state?.create_campaign) {
			this.setState({
				visible: true
			});
		}

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await CampaignService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.campaigns.rows,
			last_page: res.campaigns.count,
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	create = () => {
		this.setState({
			visible: true
		});	
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => this.load(false));	
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="campaign">
				<Modal
		          className="modal-create-campaign"
		          visible={ visible }
		          title="Crear campaña"
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-8 row">
								<div className="col-md-4">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por nombre o mensaje"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<DatePicker
										label="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-4">
									<DatePicker
										label="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
							<div className="col-md-2 text-right">
								<button className="btn btn-active" onClick={ () => this.create() }>
									Crear campaña
								</button>
							</div>
						</div>
					</div>
				</div>

				{
					this.state.data.length == 0 ? (
						<div className="text-center container-no-campaign">
							<img src={ CampaignImage } />
							<h3>No ha creado una campaña SMS</h3>
							<p>Haz click en "Crear campaña" y empieza a diseñar tu primera campaña SMS</p>
							<button className="btn btn-active" onClick={ () => this.create() }>
								Crear campaña
							</button>
						</div>
					) : (
						<Table title="Campañas" data={ this.state.data.length } header={ this.state.header }>
							{ this.state.data.map((i: any,index: number) => {
								return (
									<tr key={ index }>
										<td>{ moment(i.created_at).format('DD/MM/YYYY HH:mm') }</td>
										<td>{ i.number }</td>
										<td>{ i.content }</td>
										<td>{ i.total_messages }</td>
										<td>{ i.total_success }</td>
										<td>{ i.total_error }</td>
									</tr>
								)
							}) }
						</Table>
					)
				}

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(SendCampaign);